webpackJsonp([65644574184402],{

/***/ 2144:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Orderable","kind":"UNION","type":"OBJECT","fields":null,"description":null,"enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Product","ofType":null},{"kind":"OBJECT","name":"ProductPackage","ofType":null}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---union-orderable-065d43a6528d5db67196.js